import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '@app-core/services/http/http.service';
import { UserInformation } from '@app-models/user.model';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  API_URL = `${environment.API_DOMAIN}/${environment.API_PATH_PREFIX}`;

  constructor(private http: HttpService) {}

  public getUserInformation(userId: number): Observable<UserInformation> {
    const path = `${this.API_URL}/employee/employee/${userId}/`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const params = new HttpParams().set(
      'fields',
      `about_me,english_level,detailperson,detailWork,course_id,availability_ops,detailcandidate,sub_categoria,contact_customer,customer,experience_name,expertise_level_name,seniority,course_id,training,hired_date,visa_type,visa_expiration_date,interests,available_to_travel,driver_license,audio,availabilty_ops,skills,cv,neighborhood,profile_languages`
    );
    return this.http.get<UserInformation>(path, { headers, params });
  }

  public getDocumentTypes(): Observable<any> {
    const path = `${this.API_URL}/general/identitydocumenttype/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(path, { params, headers });
  }

  public getGenders(): Observable<any> {
    const path = `${this.API_URL}/general/gender/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(path, { params, headers });
  }

  public getMaritalStatuses(): Observable<any> {
    const path = `${this.API_URL}/recruitment/new/aplicant/marital_status/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(path, { params, headers });
  }

  public updateAvatar(userId: number, formData: FormData) {
    const path = `${this.API_URL}/employee/employee/${userId}/`;
    return this.http.put(path, formData);
  }

  public updateCV(userId: number, formData: FormData) {
    const path = `${this.API_URL}/employee/employee/${userId}/`;
    return this.http.put(path, formData);
  }

  public updateProfileUser(userId: number, body: FormData) {
    const path = `${this.API_URL}/employee/employee/${userId}/`;
    return this.http.put(path, body);
  }

  public getEducationLevels(): Observable<any> {
    const path = `${this.API_URL}/general/educationlevel/`;
    return this.http.get<any>(path);
  }

  getEducationExperienceV2(id): Observable<any> {
    const path = `${this.API_URL}/employee/profile/education_profile/?profile=${id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(path, { headers });
  }

  getEducationExperienceRetry(id): Observable<any> {
    const path = `${this.API_URL}/employee/profile/education_profile/${id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(path, { headers });
  }

  public deleteWorkExperiencev2(id, profileId): Observable<any> {
    const path = `${this.API_URL}/employee/profile/work_exp_profile/${id}?profile_id=${profileId}`;
    return this.http.delete<any>(path);
  }

  public deleteEducationv2(id, profileId): Observable<any> {
    const path = `${this.API_URL}/employee/profile/education_profile/${id}?profile_id=${profileId}`;
    return this.http.delete<any>(path);
  }

  public createEducationV2(params) {
    const path = `${this.API_URL}/employee/profile/education_profile/`;
    return this.http.post<any>(path, params);
  }

  public updateEducationExperienceV2(params, id) {
    const path = `${this.API_URL}/employee/profile/education_profile/${id}/`;
    return this.http.put<any>(path, params);
  }

  getWorkExperience(id) {
    const path = `${this.API_URL}/employee/profile/work_exp_profile/?profile=${id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(path, { headers });
  }

  getWorkExperienceRetry(id) {
    const path = `${this.API_URL}/employee/profile/work_exp_profile/${id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(path, { headers });
  }

  public updateWorkExperiences(params, id) {
    const path = `${this.API_URL}/employee/profile/work_exp_profile/${id}`;
    return this.http.put<any>(path, params);
  }

  public deleteEducation(id) {
    const path = `${this.API_URL}/employee/profiledetaileducation/${id}/`;
    return this.http.delete<any>(path);
  }
  public deleteWorkExperience(id) {
    const path = `${this.API_URL}/employee/profiledetailwork/${id}/`;
    return this.http.delete<any>(path);
  }

  public createWorkExperience(params) {
    const path = `${this.API_URL}/employee/profiledetailwork/`;
    return this.http.post<any>(path, params);
  }

  public updateEmployeeProfile(params, id) {
    const path = `${this.API_URL}/employee/employee/${id}/`;
    return this.http.put<any>(path, params);
  }
}
